var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserIconSmall = function SvgUserIconSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.798c1.607 1.648 11.844 1.556 13.97 0 .203-1.98-.627-5.013-1.92-6.3-.5 0-.966 0-1.406.003-.38.03-.702-.004-.945-.133-.278-.304-.45-.81-.56-1.436.347-.414.624-.924.789-1.493.21-.12.366-.324.471-.598.114-.296.166-.683.16-1.14l-.003-.147-.116-.083a1.598 1.598 0 0 0-.134-.086c.231-1.791-.081-2.986-.953-3.658-1.286-.991-3.695-.983-4.964.11-.816.704-1.032 1.616-.774 3.589-.023.014-.045.03-.067.045l-.117.083-.002.147c-.007.466.047.859.166 1.158.11.276.272.478.49.593.178.61.484 1.15.868 1.577-.092.484-.224.891-.418 1.18-.24.302-.593.413-1.036.37-.472.002-.973.004-1.515.004C.339 11.093.034 14.06 0 15.798z",
    fill: "#55CCDE",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserIconSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-icon-small.94c801c0.svg";
export { ForwardRef as ReactComponent };